import React from 'react'
import {
  TextField,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Input,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DurationInput from '../Step2-BreakRuleSection/DurationInput';

/**
 * @typedef {{
*  label: string,
*  placeholder: string,
*  isOverride: boolean,
*  setIsOverride: (value: boolean) => void,
*  overrideValue: number,
*  setOverrideValue: (value: number) => void,
*  helpIconTooltip?: string,
*  isDisabled?: boolean,
*  maxHoursDigits?: number,
* }} OverrideDurationProps
* @param {OverrideDurationProps} props
*/
const OverrideDuration = ({label, placeholder, isOverride, setIsOverride, overrideValue, setOverrideValue, helpIconTooltip, isDisabled, maxHoursDigits = 2}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>            
      <FormControlLabel
        control={(
          <Checkbox checked={isOverride} onClick={({ target: { checked: isChecked } }) => {setIsOverride(isChecked)}}/>
        )}
        label={label}
        disabled={isDisabled}
      />
      <div style={{ marginRight: '16px' }}>
        <DurationInput
            onChange={(value) => setOverrideValue(value * 60)}
            value={ overrideValue / 60}
            maxHoursDigits={maxHoursDigits}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            disabled={isDisabled || !isOverride}
            placeholder={placeholder}
        />
      </div>
      <Tooltip title={helpIconTooltip} arrow>
          <InfoIcon style={{ width: '15px', height: '15px', fontSize: '15px' }} />
      </Tooltip>
    </div>
  )
}

export default OverrideDuration